import { atom } from "jotai"

type CollectionGridSize = "small" | "large"

export const collectionGridSizeAtom = atom<CollectionGridSize>("small")
